import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseBase } from '../models/response-base';
import { ReceitaWsResponse } from '../models/companhia';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  private URL = environment.GATEWAY + 'company/';
  constructor(private http: HttpClient) { }
  

  getDetalhesEmpresa(cnpj: string): Observable<ResponseBase<any>> {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    let param = new HttpParams();
    param = param.append(`preRegister`, 'false');
    return this.http.get<ResponseBase<any>>(`${this.URL}details/${cnpj}`, {params: param});
  }
}
